import * as fb from 'firebase'

//Production repo
var firebaseConfig = {
    apiKey: "AIzaSyAPsuDiXcHApVcLoArmZov2DlFmnVaYy7g",
    authDomain: "mpro-mvp.firebaseapp.com",
    databaseURL: "https://mpro-mvp.firebaseio.com",
    projectId: "mpro-mvp",
    storageBucket: "mpro-mvp.appspot.com",
    messagingSenderId: "194714042588",
    appId: "1:194714042588:web:6c635f8b228c8c2a847419",
    measurementId: "G-BQWFSQ9P1M"
  };

fb.initializeApp(firebaseConfig)

var db = fb.database()

export {db}
